import { getDateTimeRangeSelection } from '../../../../Components/PropertySearch/Utility/Utility'
import { fetchPropertySearchResult, fetchPropertySearchResultForExport } from '../../Services/propertySearchService'

class getSearchResult {
    constructor(props, loadData) {
        this.searchCriteria = { ...props }
        this.loadData = loadData
    }

    createPayload() {

        const payload = {}

        if (this.searchCriteria.subjectProperty && this.searchCriteria.subjectProperty.propertyName) {
            payload.subProperty = this.createSubjectPayload()
        }

        if (this.searchCriteria.property && this.searchCriteria.property.propertyName) {
            payload.property = this.createPropertyPayload()
        }

        if (this.searchCriteria.propertyTypeFields && this.searchCriteria.propertyTypeFields.length > 0) {
            payload.propertyType = this.createTypePayload()
        }

        if (this.searchCriteria.featureFields && this.searchCriteria.featureFields.length > 0) {
            payload.features = this.createfeaturesPayload()
        }

        if (this.searchCriteria.listingStatusFields && this.searchCriteria.listingStatusFields.length > 0) {
            payload.listing = this.createlistingPayload()
        }
        if (this.searchCriteria.salesFields && this.searchCriteria.salesFields.length > 0) {
            payload.sales = this.createSalesPayload()
        }
        if (this.searchCriteria.accountFields && this.searchCriteria.accountFields.length > 0) {
            payload.account = this.createAccountPayload()
        }
        if (this.searchCriteria.tenantInfoFields && this.searchCriteria.tenantInfoFields.length > 0) {
            payload.tenantInfo = this.createTenantPayload()
        }
        if (this.searchCriteria.loanFields && this.searchCriteria.loanFields.length > 0) {
            payload.loan = this.createLoanPayload()
        }
        if (this.searchCriteria.locationFields && this.searchCriteria.locationFields.length) {
            payload.location = this.createLocationPayload()
        }
        if (this.searchCriteria.prospecting && this.searchCriteria.prospecting.length) {
            payload.prospecting = this.createProspectingPayload()
        }
        if (this.searchCriteria.polygon && this.searchCriteria.polygon.points.length > 0) {
            payload.polygon = this.searchCriteria.polygon
        }

        if (Object.keys(this.searchCriteria.sort).length) {
            payload.sort = this.createSortPayload()
        }

        payload.pagination = this.createPaginationPayload()

        return payload
    }

    createSubjectPayload() {
        const subProperty = {}
        subProperty.id = this.searchCriteria.subjectProperty.omniViewPropertyId

        if (!this.searchCriteria.distanceFields.length) {
            this.searchCriteria.distanceFields.push({ value: '5' })
        }
        subProperty.distance = parseFloat(this.searchCriteria.distanceFields[0].value)

        // this condition will only true when there is a landmark as POI in saved search from OV
        if (this.searchCriteria.subjectProperty.propertyLocation && subProperty.id === '') {
            subProperty.propertyLocation = this.searchCriteria.subjectProperty.propertyLocation
        }

        return subProperty
    }

    createPropertyPayload() {
        const property = {}
        property.propertyName = this.searchCriteria.property.propertyName
        if (this.searchCriteria.property.priorName) {
            property.priorName = this.searchCriteria.property.priorName
        }

        return property
    }

    createSortPayload() {
        const sort = {}

        for (const [key, value] of Object.entries(this.searchCriteria.sort)) {
            sort[key] = value
        }

        return sort
    }

    createPaginationPayload() {
        const pagination = {}

        for (const [key, value] of Object.entries(this.searchCriteria.pagination)) {
            pagination[key] = value
        }

        return pagination
    }

    createTypePayload() {
        const propertyType = {}

        const lstPropertyTypes = this.searchCriteria.propertyTypeFields.filter(x => x.subtype === 'all')
        const uniquePropertyType = [...new Set(this.searchCriteria.propertyTypeFields.map(item => item.propertytype))]

        uniquePropertyType.forEach(item => {
            const lstSubtype = this.searchCriteria.propertyTypeFields.filter(x => x.propertytype === item && x.subtype !== 'all')
            const selectedSubtype = []
            lstSubtype.forEach(subItem => {
                selectedSubtype.push(subItem.subtype)
            })
            if (lstSubtype.length > 0) {
                propertyType[item] = selectedSubtype
            }
        })

        lstPropertyTypes.forEach(item => {
            propertyType[item.propertytype] = 'all'
        })

        return propertyType
    }

    createLocationPayload() {
        const locationType = {}
        const lstLocationTypes = this.searchCriteria.locationFields.filter(x => x.locationValue === 'all')
        const uniqueLocationType = [...new Set(this.searchCriteria.locationFields.map(item => item.locationType))]
        const fieldComponents = {
            'State': 'state',
            'City': 'city',
            'County': 'propertyPropertyCounty',
            'Zip Code': 'zipCode'
        }
        uniqueLocationType.forEach(item => {
            const lstSubtype = this.searchCriteria.locationFields.filter(x => x.locationType === item && x.locationValue !== 'all')
            const selectedSubtype = []
            lstSubtype.forEach(subItem => {
                selectedSubtype.push(subItem.locationValue)
            })
            if (lstSubtype.length > 0) {
                locationType[fieldComponents[item]] = selectedSubtype
            }
        })
        lstLocationTypes.forEach(item => {
            locationType[item.locationType] = 'all'
        })

        return locationType
    }

    createProspectingPayload() {
        const prospecting = []

        this.searchCriteria.prospecting.forEach(item => {
            let newItem = { ...item }
            delete newItem.selectedItem
            delete newItem.combinedLocation

            prospecting.push(newItem)
        })

        return prospecting
    }

    createfeaturesPayload() {
        const features = {}
        this.searchCriteria.featureFields.forEach(item => {
            if (item.minValue !== '' || item.maxValue !== '') {

                let { minValue, maxValue } = item

                if (item.type === 'number' || item.type === 'currency' || item.type === 'date' || item.type === 'percent') {
                    minValue = isNaN(parseFloat(minValue)) ? '' : parseFloat(minValue)
                    maxValue = isNaN(parseFloat(maxValue)) ? '' : parseFloat(maxValue)
                }

                if (item.isMinMax) {
                    features[item.fieldName] = [minValue, maxValue]
                }
                if (!item.isMinMax) {
                    features[item.fieldName] = minValue
                }
            }
        })

        return features
    }

    createSalesPayload() {
        const sales = {}
        this.searchCriteria.salesFields.forEach(item => {
            if (item.minValue !== '' || item.maxValue !== '') {

                let { minValue, maxValue } = item

                if (item.type === 'number' || item.type === 'currency' || item.type === 'percent') {
                    minValue = isNaN(parseFloat(minValue)) ? '' : parseFloat(minValue)
                    maxValue = isNaN(parseFloat(maxValue)) ? '' : parseFloat(maxValue)
                }

                if (item.isMinMax) {
                    sales[item.fieldName] = [minValue, maxValue]
                }
                if (!item.isMinMax) {
                    sales[item.fieldName] = minValue
                }
            }
            if (item.startValue !== '' || item.endValue !== '') {
                const { startValue, endValue } = item

                if (item.isStartEnd) {
                    sales[item.fieldName] = [startValue, endValue]
                }
            }
        })

        return sales
    }

    createAccountPayload() {
        const account = {}

        let item = this.searchCriteria.accountFields[0]
        account[item.fieldName] = item.accountId

        item = this.searchCriteria.accountFields[1]
        account[item.fieldName] = item.value

        return account
    }

    createTenantPayload() {
        const tenantInfo = {}
        this.searchCriteria.tenantInfoFields.forEach(item => {
            const selectedValues = []
            item.groupList.forEach(list => {
                if (list.selected) {
                    if (item.type === 'radio' && list.isChanged) {
                        tenantInfo[item.fieldName] = list.key
                    } else {
                        selectedValues.push(list.key)
                    }
                }
            })
            if (item.type === 'checkbox') {
                tenantInfo[item.fieldName] = selectedValues
            }
        })

        return tenantInfo
    }

    createlistingPayload() {
        const listing = {}
        this.searchCriteria.listingStatusFields.forEach(item => {
            if (item.isChecked) {
                listing[item.fieldName] = true
            }
            if (item.type == 'date') {
                if (item.startValue !== '' || item.endValue !== '') {
                    const { startValue, endValue } = item
                    if (item.isStartEnd) {
                        listing[item.fieldName] = [startValue, endValue]
                    }
                }
            }
        })
        return listing
    }

    createLoanPayload() {
        const loan = {}
        this.searchCriteria.loanFields.forEach(item => {
            if (item.minValue !== '' || item.maxValue !== '') {
                let { minValue, maxValue } = item
                if (item.type === 'number' || item.type === 'currency' || item.type === 'percent') {
                    minValue = isNaN(parseFloat(minValue)) ? '' : parseFloat(minValue)
                    maxValue = isNaN(parseFloat(maxValue)) ? '' : parseFloat(maxValue)
                }
                // if(item.isStartEnd && item.startValue !== '' || item.endValue !== '' ) {
                //   minValue = minValue ? getDateTimeRangeSelection(minValue) : minValue
                //   maxValue = maxValue ? getDateTimeRangeSelection(maxValue) : maxValue
                // }
                if (item.propId === "timeRange") {
                    minValue = minValue !== "" ? getDateTimeRangeSelection(minValue) : minValue
                    maxValue = maxValue !== "" ? getDateTimeRangeSelection(maxValue) : maxValue
                }
                if (item.isMinMax) {
                    loan[item.fieldName] = [minValue, maxValue]
                }
                if (!item.isMinMax) {
                    loan[item.fieldName] = minValue
                }
            }
            if (item.startValue !== '' || item.endValue !== '') {
                const { startValue, endValue } = item

                if (item.isStartEnd) {
                    loan[item.fieldName] = [startValue, endValue]
                }
            }
            if (item.optionsList && item.value) {
                loan[item.fieldName] = item.value
            }
            if (item.groupList) {
                item.groupList.forEach(list => {
                    if (list.selected && item.type === 'radio') {
                        loan[item.fieldName] = list.val
                    }
                })
            }
        })

        return loan
    }

    async fetchSearchResult() {

        try {
            const payload = this.createPayload()
            const response = await fetchPropertySearchResult(payload)
            if (response && response.status === 200) {
                // console.log('fetchSearchResult :::', response.data)
                this.loadData(response, false)
            }
            return response
        } catch (error) {
            console.log('error in fetchSearchResult:::', error)
        }

    }

    async fetchSearchResultForExport() {

        try {
            const payload = this.createPayload()
            const response = await fetchPropertySearchResultForExport(payload)
            if (response && response.status === 200) {
                this.loadData(response, false)
            }
            return response
        } catch (error) {
            console.log('error in fetchSearchResultForExport:::', error)
        }

    }

    async fetchWildSearchResult() {

        try {
            const payload = this.createPayload()
            delete payload.sort
            console.log('payload :::', payload)
            const response = await fetchPropertySearchResult(payload)
            if (response && response.status === 200) {
                // console.log('fetchSearchResult :::', response.data)
                this.loadData(response, false)
            }
            return response
        } catch (error) {
            console.log('error in fetchSearchResult:::', error)
        }

    }

}

export default getSearchResult
